
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import { decimalFormat } from '@/helpers/decimalFormat';
import FadeTwin from '@/components/UI/fade-twin.vue';
import PrescriptionTemplateModel from '@/models/prescription-template-model';

@Component({
  components: { FadeTwin },
})
export default class ClientesResumeProducts extends BaseComponent {
  @Prop()
  public data: any;

  @Prop()
  public item: PrescriptionTemplateModel;

  public selectedClients: any[] = [];

  public getFadeTwinLabel(id): string {
    return 'prod' + id;
  }
  public getUnitTyped(units): any {
    const unit = units.find((item) => {
      return item.digitado;
    });
    return unit || {};
  }

  @Watch('item')
  public onValueChange(val): void {   
   this.prepareSelectedClients();
  }

  @Watch('data')
  public onUnidadesChange() {
    this.prepareSelectedClients();
  }

  prepareSelectedClients() {
    if (!this.item || !this.item.unidadesCliente || !this.data) {
      return;
    }
    this.selectedClients = this.data.filter(u => this.item.unidadesCliente.findIndex(ut => ut.id == u.id) != -1);
  }

  public beforeMount(): void {}

  public decimalFormat(val): string {
    return decimalFormat(val);
  }

  public onSelect(): void {
    if (this.selectedClients) {
      this.item.unidadesCliente = this.selectedClients;
    }
  }
}
